import { Model } from '@/clients/http'

import { StockHttpParams, StockResponses } from '@/types'

export class StockModel extends Model {
  public static readonly correlations = {
    GET_HISTORY: 'GET_STOCK_HISTORY',
    GET_BY_ID: 'GET_STOCK_TRANSACTION_BY_ID',
    CREATE_PURCHASE: 'CREATE_STOCK_PURCHASE',
    CREATE_ADJUSTMENT: 'CREATE_STOCK_ADJUSTMENT',
  }

  public static readonly endpoints = {
    getHistory: (props?: StockHttpParams.GetHistory) =>
      this.createEndpoint({
        url: '/api/backoffice/stock/history',
        params: props?.params,
        query: props?.query,
      }),

    getById: (props?: StockHttpParams.GetById) =>
      this.createEndpoint({
        url: '/api/backoffice/stock/transaction/:id',
        params: props?.params,
        query: props?.query,
      }),

    purchase: (props?: StockHttpParams.CreatePurchase) =>
      this.createEndpoint({
        url: '/api/backoffice/stock/purchase',
        params: props?.params,
        query: props?.query,
      }),

    adjust: (props?: StockHttpParams.CreateAdjustment) =>
      this.createEndpoint({
        url: '/api/backoffice/stock/adjust',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getHistory = async (props?: StockHttpParams.GetHistory) => {
    return this.createHttpRequest<StockResponses.GetHistory, StockResponses.GetHistoryError>({
      correlationKey: this.correlations.GET_HISTORY,
      payload: {
        method: 'get',
        url: this.endpoints.getHistory(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly getById = async (props: StockHttpParams.GetById) => {
    return this.createHttpRequest<StockResponses.GetById, StockResponses.GetByIdError>({
      correlationKey: this.correlations.GET_BY_ID,
      payload: {
        method: 'get',
        url: this.endpoints.getById(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly purchase = async (props: StockHttpParams.CreatePurchase) => {
    return this.createHttpRequest<StockResponses.CreatePurchase, StockResponses.CreatePurchaseError>(
      {
        correlationKey: this.correlations.CREATE_PURCHASE,
        payload: {
          method: 'post',
          url: this.endpoints.purchase(props),
          body: props.body,
          useBearerToken: true,
        },
        store: props?.store,
      }
    )
  }

  public static readonly adjust = async (props: StockHttpParams.CreateAdjustment) => {
    return this.createHttpRequest<
      StockResponses.CreateAdjustment,
      StockResponses.CreateAdjustmentError
    >({
      correlationKey: this.correlations.CREATE_ADJUSTMENT,
      payload: {
        method: 'post',
        url: this.endpoints.adjust(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
